export const toLowercaseAndRemoveWhitespace = (value: string) => value.toLowerCase().replace(/\s/g, '');
export const lowerCaseIncludes = (parent: string, child: string) => parent.toLowerCase().includes(child.toLowerCase());
export const addSpacesBetweenCapitals = (value: string) => value.replace(/([A-Z])/g, ' $1').trim();
